import semaphoreLocksApi from '../api/SemaphoreLocksApi';
import * as commonActions from './commonActions';

export const GET_SEMAPHORE_LOCKS='GET_SEMAPHORE_LOCKS';

export const semaphoreLocksActions = {
    getSemaphoreLocks: () => (dispatch) => {
        dispatch({
            type: commonActions.LOADING,
            value: true
        });
        semaphoreLocksApi.getSemaphoreLocks().then(data=>{
            dispatch({ type: GET_SEMAPHORE_LOCKS, data });
            dispatch({
                type: commonActions.LOADING,
                value: false
            });
        });
    },
    unlockSemaphore: (semaphore) =>(dispatch) =>{
        dispatch({
            type: commonActions.LOADING,
            value: true
        });
        semaphoreLocksApi.unlockSemaphore(semaphore).then(data=>{
            if (data.error == null) {
                dispatch({ type: GET_SEMAPHORE_LOCKS, data });
            }
            else {
                dispatch({
                    type: commonActions.SET_MESSAGE,
                    value: {
                        text: data.error
                    }
                });
            }
            dispatch({
                type: commonActions.LOADING,
                value: false
            });
        });
    },
    unlockAllSemaphores: () =>(dispatch) =>{
        dispatch({
            type: commonActions.LOADING,
            value: true
        });
        semaphoreLocksApi.unlockAllSemaphores().then(data=>{
            if (data.error == null) {
                var message = {
                    text: "All semaphore locks successsfuly released"
                };
                dispatch({
                    type: commonActions.SET_MESSAGE,
                    value: message
                });
                dispatch({ type: GET_SEMAPHORE_LOCKS, data });
            }
            else {
                dispatch({
                    type: commonActions.SET_MESSAGE,
                    value: {
                        text: data.error
                    }
                });
            }
            dispatch({
                type: commonActions.LOADING,
                value: false
            });
        });
    }
};